(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero-ar"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (window.__arFadeInit) return;
  window.__arFadeInit = true;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('ar-visible'); });
  }, { threshold: 0.08 });
  document.querySelectorAll('.ar-fade-in').forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-landing-conversion-ar"] && !Shopify.designMode) return;
  try {
    
(function(){
  var form    = document.getElementById('lp-cod-form');
  var success = document.getElementById('lp-cod-success');
  var errMsg  = document.getElementById('lp-cod-error');
  var btn     = document.getElementById('lp-cod-btn');
  if(!form) return;

  form.addEventListener('submit', function(e){
    e.preventDefault();

    var name    = document.getElementById('cod-name').value.trim();
    var phone   = document.getElementById('cod-phone').value.trim();
    var city    = document.getElementById('cod-city').value.trim();
    var address = document.getElementById('cod-address').value.trim();

    if(!name || !phone || !city || !address){
      errMsg.style.display = 'flex';
      return;
    }
    errMsg.style.display = 'none';

    btn.disabled    = true;
    btn.textContent = '⏳ جاري إرسال الطلب...';

    var variantId = parseInt(document.getElementById('lp-vid').value, 10);
    var note = 'طلب COD\nالاسم: ' + name + '\nالهاتف: ' + phone + '\nالمدينة: ' + city + '\nالعنوان: ' + address;

    /* 1 — Add to cart */
    var addPayload = { items: [{ id: variantId, quantity: 1 }] };
    if(!variantId){ addPayload = null; }

    var addPromise = variantId
      ? fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addPayload)
        })
      : Promise.resolve();

    addPromise
      .then(function(){
        /* 2 — Set cart note + attributes */
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            note: note,
            attributes: {
              'الاسم':    name,
              'الهاتف':   phone,
              'المدينة':  city,
              'العنوان':  address
            }
          })
        });
      })
      .then(function(){
        /* 3 — Show success, then redirect to checkout */
        form.style.display = 'none';
        success.style.display = 'block';
        document.getElementById('lp-confirm-phone').textContent = phone;
        setTimeout(function(){ window.location.href = '/checkout'; }, 3000);
      })
      .catch(function(){
        btn.disabled    = false;
        btn.textContent = '{{ section.settings.cta_text | default: "اطلب هلق — الدفع عند الاستلام 🔥" }}';
        errMsg.style.display = 'flex';
        errMsg.textContent   = '❌ صار خطأ. حاول مرة تانية.';
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-landing-faq-ar"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.lp-faq-item').forEach(function(item){
    item.querySelector('.lp-faq-trigger').addEventListener('click', function(){
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.lp-faq-item').forEach(function(i){
        i.classList.remove('open');
        i.querySelector('.lp-faq-content').style.maxHeight = '0';
      });
      if(!wasOpen){
        item.classList.add('open');
        var c = item.querySelector('.lp-faq-content');
        c.style.maxHeight = c.scrollHeight + 'px';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-landing-hero-ar"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* countdown timer — 24h session-persistent */
  var KEY = 'atk_lp_end', DUR = 24*3600*1000;
  var end = parseInt(localStorage.getItem(KEY) || '0');
  if(!end || Date.now() > end){ end = Date.now() + DUR; localStorage.setItem(KEY, end); }
  function pad(n){ return String(n).padStart(2,'0'); }
  function tick(){
    var r = end - Date.now();
    if(r <= 0){ localStorage.removeItem(KEY); location.reload(); return; }
    var h = Math.floor(r/3600000), m = Math.floor((r%3600000)/60000), s = Math.floor((r%60000)/1000);
    document.querySelectorAll('.lp-cd-h').forEach(function(e){ e.textContent = pad(h); });
    document.querySelectorAll('.lp-cd-m').forEach(function(e){ e.textContent = pad(m); });
    document.querySelectorAll('.lp-cd-s').forEach(function(e){ e.textContent = pad(s); });
  }
  tick(); setInterval(tick, 1000);

  /* live viewers */
  function rnd(){ return Math.floor(Math.random()*9)+11; }
  document.querySelectorAll('.lp-live-count').forEach(function(e){ e.textContent = rnd(); });
  setInterval(function(){
    var n = rnd();
    document.querySelectorAll('.lp-live-count').forEach(function(e){ e.textContent = n; });
  }, 45000);

  /* sticky ATC */
  var hero = document.getElementById('lp-hero');
  var satc = document.getElementById('lp-sticky-atc');
  if(hero && satc){
    new IntersectionObserver(function(entries){
      satc.classList.toggle('visible', !entries[0].isIntersecting);
    },{threshold:0}).observe(hero);
  }

  /* fade-in */
  if(!window.__lpFadeInit){
    window.__lpFadeInit = true;
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('visible'); });
    },{threshold:0.08});
    document.querySelectorAll('.lp-fade-in').forEach(function(el){ obs.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-faq-ar"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.prd-faq-item').forEach(function(item){
    item.querySelector('.prd-faq-trigger').addEventListener('click', function(){
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.prd-faq-item').forEach(function(i){
        i.classList.remove('open');
        i.querySelector('.prd-faq-content').style.maxHeight = '0';
      });
      if(!wasOpen){
        item.classList.add('open');
        var c = item.querySelector('.prd-faq-content');
        c.style.maxHeight = c.scrollHeight + 'px';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-main-ar"] && !Shopify.designMode) return;
  try {
    
(function(){
  var mainImg = document.getElementById('prd-main-img');
  var thumbs = document.querySelectorAll('.prd-gallery-thumb');
  var imgs = [];
  thumbs.forEach(function(t){ if(t.dataset.src) imgs.push(t.dataset.src); });
  var currentIdx = 0;

  function goTo(idx){
    if(!imgs.length || !mainImg) return;
    currentIdx = ((idx % imgs.length) + imgs.length) % imgs.length;
    mainImg.classList.add('switching');
    setTimeout(function(){ mainImg.src = imgs[currentIdx]; mainImg.classList.remove('switching'); }, 200);
    thumbs.forEach(function(t, i){ t.classList.toggle('active', i === currentIdx); });
    var activeThumb = thumbs[currentIdx];
    if(activeThumb) activeThumb.scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'});
  }

  thumbs.forEach(function(thumb, i){
    thumb.addEventListener('click', function(){ goTo(i); });
  });

  var prevBtn = document.getElementById('prd-gallery-prev');
  var nextBtn = document.getElementById('prd-gallery-next');
  if(prevBtn) prevBtn.addEventListener('click', function(){ goTo(currentIdx - 1); });
  if(nextBtn) nextBtn.addEventListener('click', function(){ goTo(currentIdx + 1); });

  var touchX = 0;
  var galleryEl = document.querySelector('.prd-gallery-main');
  if(galleryEl){
    galleryEl.addEventListener('touchstart', function(e){ touchX = e.touches[0].clientX; }, {passive:true});
    galleryEl.addEventListener('touchend', function(e){
      var diff = touchX - e.changedTouches[0].clientX;
      if(Math.abs(diff) > 40) goTo(diff > 0 ? currentIdx + 1 : currentIdx - 1);
    });
  }

  var qtyInput = document.querySelector('.prd-qty-num');
  var qtyMinus = document.getElementById('prd-qty-minus');
  var qtyPlus  = document.getElementById('prd-qty-plus');
  if(qtyMinus) qtyMinus.addEventListener('click', function(){ if(parseInt(qtyInput.value)>1) qtyInput.value = parseInt(qtyInput.value)-1; });
  if(qtyPlus)  qtyPlus.addEventListener('click', function(){ if(parseInt(qtyInput.value)<10) qtyInput.value = parseInt(qtyInput.value)+1; });

  var sizeGrid = document.getElementById('prd-size-grid');
  var selSizeLabel = document.getElementById('prd-sel-size');
  if(sizeGrid){
    sizeGrid.querySelectorAll('.prd-size-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        sizeGrid.querySelectorAll('.prd-size-btn').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        if(selSizeLabel) selSizeLabel.textContent = btn.dataset.value;
      });
    });
  }

  var colorRow = document.getElementById('prd-color-row');
  var selColorLabel = document.getElementById('prd-sel-color');
  if(colorRow){
    colorRow.querySelectorAll('.prd-color-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        colorRow.querySelectorAll('.prd-color-btn').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        if(selColorLabel) selColorLabel.textContent = btn.dataset.value;
      });
    });
  }

  if(!window.__prdFadeInit){
    window.__prdFadeInit = true;
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('visible'); });
    },{threshold:0.08});
    document.querySelectorAll('.prd-fade-in').forEach(function(el){ obs.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-tabs-ar"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Tab switching
  var tabs = document.querySelectorAll('.prd-tab-btn');
  tabs.forEach(function(btn){
    btn.addEventListener('click', function(){
      tabs.forEach(function(b){ b.classList.remove('active'); });
      document.querySelectorAll('.prd-tab-panel').forEach(function(p){ p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById('prd-tab-' + btn.dataset.tab);
      if(panel) panel.classList.add('active');
    });
  });

  // Read more toggle
  document.querySelectorAll('.prd-readmore-btn').forEach(function(btn){
    var wrap = document.getElementById(btn.dataset.target);
    if(!wrap) return;
    btn.addEventListener('click', function(){
      var expanded = wrap.classList.toggle('expanded');
      btn.textContent = expanded ? btn.dataset.less : btn.dataset.more;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
